import React from 'react';
import { 
  circleColor, 
  format, 
  readOnlyFill, 
  fillUpside, 
  priceColor, 
  fillFiftyDayAvg,
  fillMLPrice, 
  earningDateColor, 
  fillMaxMin, 
  formatPercent, 
  fillStockWeight,
  stockReportLink
} from '../Helpers';

const TableRow = ({ sector, tickerInfo, openModal, theme, hide, customizations }) => {
  
  const tickerAr = tickerInfo.filter(item => item.sector_id === sector);
  if (tickerAr.length < 1) return null;

  return (
    tickerAr.map((item) => {



      return (
        <tr key={item.symbol} className={theme}>

          <td className={fillMLPrice(item.BofAML12, item.price)}>
            {format(item.BofAML12)}
          </td>

          <td className={fillUpside(item.upside)}>
            {formatPercent(item.upside)}
          </td>

          <td className={fillFiftyDayAvg(item.fiftyDayMovingAvg, item.price)}>
            {format(item.fiftyDayMovingAvg)}
          </td>

          <td className={readOnlyFill(item.resistance, item.price)} >
            {item.resistance}
          </td>

          <td className={readOnlyFill(item.price, item.support)} >
            {item.support}
          </td>

            <td style={{textAlign: 'center'}}
                className={fillStockWeight(item.stockWeight, customizations[0].tickerWeightGreen,
                    customizations[0].tickerWeightRed)}>

                {formatPercent(item.stockWeight)}
            </td>


            <td className={earningDateColor(item.earningsDate)}
                style={{textAlign: 'left', cursor: 'pointer'}}
                onClick={() => openModal(item)}>
            <span className={item.strikethrough ? 'strikethrough' : null}>
              {item.name} ({item.symbol})
            </span>
          </td>

          <td>
            {format(item.price)}
          </td>

          <td className={priceColor(item.percentChange)}>
            {formatPercent(item.percentChange)}
          </td>

          <td className="circle-container">
            <a
              className={circleColor(item.MLRating)}
              // href={stockReportLink({ symbol: item.symbol, type: 'ML' })}
              target="_blank">
            </a>
          </td>

          {/*<td className="circle-container">*/}
          {/*  <a*/}
          {/*    className={circleColor(item.MSRating)}*/}
          {/*    href={stockReportLink({ symbol: item.symbol, type: 'MS' })}*/}
          {/*    target="_blank">*/}
          {/*  </a>*/}
          {/*</td>*/}

          {/*<td className="circle-container">*/}
          {/*  <a*/}
          {/*    className={circleColor(item.SNPRating)}*/}
          {/*    href={stockReportLink({ symbol: item.symbol, type: 'SnP' })}*/}
          {/*    target="_blank">*/}
          {/*  </a>*/}
          {/*</td>*/}
    
          <td></td>
          <td></td>
          <td></td> 
          <td></td>
          <td></td>
          <td></td> 
          <td></td>
          <td></td>

          <td style={hide()}>
            {item.quarterly}
          </td>

          <td></td>
    
          <td className={fillMaxMin(item.alphaPerf, 'alphaPerf', tickerInfo)}>
            {formatPercent(item.alphaPerf)}
          </td>

          <td style={hide()}>
            {format(item.quarterlyTotal)}
          </td>

          <td style={hide()}>
            {item.adjCostbasis}
          </td>

          <td style={hide()}></td>
          <td style={hide()}></td>
          <td></td>
          <td></td>
          <td style={hide()}></td>
          <td style={hide()}></td>
          <td style={hide()}></td>
          <td></td>
          <td></td>
          <td></td>

          <td style={hide()}>
            {item.shares}
          </td>

          <td style={hide()}>
            {format(item.stockValue)}
          </td>

          <td>
            {item.deck}
          </td>

          <td style={hide()}>
            {item.notes}
          </td>

        </tr>
      )
    })   
  );
}

export default TableRow;